import { Globe } from 'lucide-react'
import { useNavigate, useRouterState } from '@tanstack/react-router'
import { useLanguage } from '../use-language'
import { useCurrentLang } from '../use-current-lang'
import { replaceSupportedLanguageInHref } from '../localized-path'
import { LIVE_LANGUAGES } from '../supported-languages'
import type { AppLanguage } from '../use-language'

const labels: Record<AppLanguage, string> = {
  ru: 'RU',
  en: 'EN',
}

export function FloatingLanguageToggle() {
  const { setLanguage } = useLanguage()
  const currentLang = useCurrentLang()
  const navigate = useNavigate()
  const href = useRouterState({ select: (state) => state.location.href })

  // Nothing to switch to while only one language is live.
  if (LIVE_LANGUAGES.length < 2) return null

  const toggle = () => {
    const nextLang: AppLanguage = currentLang === 'ru' ? 'en' : 'ru'
    setLanguage(nextLang)

    const nextHref = replaceSupportedLanguageInHref(href, nextLang)
    void navigate({ href: nextHref, replace: true, resetScroll: false })
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className="fixed bottom-4 left-4 z-[60] flex items-center gap-1.5 rounded-full border border-border bg-card/90 px-3 py-1.5 text-xs font-medium text-foreground shadow-lg backdrop-blur transition-colors hover:bg-accent"
    >
      <Globe className="h-3.5 w-3.5" />
      {labels[currentLang]}
    </button>
  )
}
